<template>
    <v-menu offset-y :close-on-content-click="false">
        <template v-slot:activator="{ on, attrs }">
            <TextField 
                :label="$t('Дата и время')"
                v-model="order_datetime"
                hide-details
                readonly
            >
                <template #append-inner>
                    <v-btn small icon color="primary" v-bind="attrs" v-on="on">
                        <v-icon>mdi-pen</v-icon>
                    </v-btn>
                </template>
            </TextField>
        </template>
        <v-card>
            <div v-if="OrderDateTime" class="d-flex flex-nowrap" style="max-height: 350px; overflow: hidden">
                <CalendarOrder style="height: 100%" @picked = "time_select" v-model="OrderDateTime" :config="this.$store.getters.local_refs.schedule.intervals" :max_days="days_forward"/>
                <TimePickerOrder 
                    v-if="OrderDateTime"
                    v-model="OrderDateTime" 
                    :min="interval_day.interval.start" 
                    :max="interval_day.interval.end" 
                    :step="10" 
                    @picked = "time_select"
                    style="height: 100%"
                />
            </div>
        </v-card>
    </v-menu>
</template>

<script>
import { DateTime } from 'luxon';

import TextField from '../../../../common/TextField.vue';

import { IntervalService } from '@/helpers/order_datetime';
import CalendarOrder from './CalendarOrder.vue';
import TimePickerOrder from './TimePickerOrder.vue';

export default{
    props: {
        value: {
            type: Object
        },
        minute_step:{
            type: Number,
            default: 10
        },
        days_forward:{
            type: Number,
            default: 14
        },
        order_type: String
    },
    data() {
        return {
            interval: null,
            time: null,
            time_selected: false,
            active_date: DateTime.now(),
            active_time: null,
            days_count: 0
        };
    },
    computed: {
        active_day:{
            get(){
                return this.active_date
            },
            set(v){
                this.active_date = v
            }
        },
        OrderDateTime:{
            get(){
                return this.value
            },
            set(v){
                this.$emit('input', v)
            }
        },
        order_datetime() {
            if(this.OrderDateTime)
                return this.OrderDateTime?.toFormat('dd.LL.yyyy HH:mm');

            return this.$t('Нерабочие дни')
        },
        interval_service(){
            if(this.$store.getters.local_refs.schedule)
                return new IntervalService(this.$store.getters.local_refs.schedule, DateTime.now(), this.days_forward)
            
            return undefined
        },
        intervals(){
            return this.interval_service?.duration_forward
        },
        interval_day(){
            let intervals = this.interval_service?.duration_forward.find(item => item.date.ts == this.OrderDateTime.startOf('day').ts)
            return intervals
        },
        before_interval(){
            if(this.interval_day.interval == undefined)
                return false
            return this.OrderDateTime < DateTime.now().set({...this.interval_day.interval.start})
        },
        after_interval(){
            if(this.interval_day.interval == undefined)
                return true
            return this.OrderDateTime > DateTime.now().set({...this.interval_day.interval.end})
        }
    },
    methods:{
        time_select(){
            this.time_selected = true
            clearInterval(this.interval)
        }, 

        find_nearest_work_date(){
            let position = this.intervals.findIndex((item) => {
                return item.date.startOf('day').ts == this.OrderDateTime.startOf('day').ts
            })
            
            let active_dates = this.intervals.slice(position+1)

            if(active_dates != []){
                let date = active_dates.find((item) => item.interval)
                this.OrderDateTime = date.date ? date.date.set({
                    hour: date.interval.start.hour,
                    minute: date.interval.end.minute
                }) : undefined
                return
            }

            this.OrderDateTime = undefined
        },

        calc_step_minute(){
            let hour = this.OrderDateTime.hour
            let time = Math.ceil(this.time.minute/this.minute_step)*this.minute_step 
            if(time >= 60){
                this.OrderDateTime = this.OrderDateTime.set({
                    hour: hour + 1,
                    minute: time - 60
                })
            }else{
                this.OrderDateTime=this.OrderDateTime.set({
                    hour: hour,
                    minute: time
                })
            }
        },
        
        check_time(){
            if(this.before_interval){
                this.OrderDateTime = DateTime.now().set({...this.interval_day.start})
                this.time_select()
                return
            }

            if(this.after_interval){
                this.find_nearest_work_date()
                this.time_select()
            }
            
           
            this.calc_step_minute()

            
        }
    },
    beforeDestroy() {
        clearInterval(this.interval);
    },
    created() {
        this.time = DateTime.now()
        this.interval = setInterval(() => {
            this.time = DateTime.now();
        }, 1000);
    },
    mounted(){
        if(this.order_type == "delivery"){
            this.OrderDateTime = this.time.plus({hours: 1})
        }else{
            this.OrderDateTime = this.time
        }
    },
    watch:{
        time(){
            if(this.time){
                this.check_time()
            }
        },
        order_type(){
            if(this.order_type == "delivery"){
                this.OrderDateTime = this.time.plus({hours: 1})
            }else{
                this.OrderDateTime = this.time
            }
        }

    },
    components: { TextField, CalendarOrder, TimePickerOrder }
}
</script>